function initializeReadersProductCard() {
  const readersProductCards = document.querySelectorAll(
    ".readers-product-card",
  );

  readersProductCards.forEach((cards) => {
    const productCardDetails = cards.querySelector(
      ".readers-product-card-details",
    );
    const productCardDetailsWrapper = productCardDetails.querySelector(
      ".readers-product-card-details-wrapper",
    );
    const productCardActions = productCardDetails.querySelector(
      ".readers-product-card-actions",
    );
    const productCardActionButtons = productCardActions.querySelectorAll(
      ".readers-product-card-actions-buttons",
    );
    const productCardPrices = productCardDetailsWrapper.querySelector(
      ".readers-product-card-prices",
    );
    const productCardVariants = productCardDetailsWrapper.querySelector(
      ".readers-product-card-variants",
    );
    const readersProductCardswatches = productCardDetailsWrapper.querySelector(
      ".readers-product-card-swatches",
    );
    const productCardVariantsList = productCardVariants.querySelectorAll("li");
    const productCardPriceList = productCardPrices.querySelectorAll("li");
    const readersProductCardswatchList =
      readersProductCardswatches.querySelectorAll(
        "#readers-product-card-swatch",
      );

    const productImages = cards.querySelector(".readers-product-card-images");
    const productImageList = productImages.querySelectorAll("img");

    const productColorValues = getProductColorValues({
      readersProductCardswatches,
    });

    let availableProductColors = {};

    readersProductCardswatchList.forEach((swatch) => {
      const productColorName = swatch.dataset.handleName;

      if (availableProductColors.hasOwnProperty(productColorName)) {
        swatch.style.display = "none";
      }

      if (productColorValues.includes(productColorName)) {
        availableProductColors = Object.assign(availableProductColors, {
          [productColorName]: productColorName,
        });
      }

      swatch.addEventListener("click", function (event) {
        const { target } = event;
        const { dataset } = target;
        const { variantId } = dataset;

        productCardActions.dataset.variantId = variantId;

        if (variantId) {
          productCardVariantsList.forEach((variant) => {
            const { variantId: variantDisplayId } = variant.dataset;
            variant.style.display =
              variantDisplayId === variantId ? "block" : "none";
          });

          productCardPriceList.forEach((price) => {
            const { variantId: variantPriceId } = price.dataset;
            price.style.display =
              variantPriceId === variantId ? "block" : "none";
          });

          productImageList.forEach((image) => {
            const { variantId: variantImageId } = image.dataset;
            image.style.display =
              variantImageId === variantId ? "block" : "none";
          });

          readersProductCardswatchList.forEach((swatchItem) => {
            const { variantId: variantSwatchItem } = swatchItem.dataset;

            if (variantSwatchItem === variantId) {
              swatchItem.classList.add("current-active-swatch");
            } else {
              swatchItem.classList.remove("current-active-swatch");
            }
          });
        }

        productCardActionButtons.forEach((buttons) => {
          const { variantId: variantDisplayId, isAvailable } = buttons.dataset;
          buttons.style.display =
            variantDisplayId === variantId ? "flex" : "none";
          // const [normalButton, waitlistButton] = buttons.querySelectorAll("a");

          // normalButton.style.display = isAvailable === "true" ? "flex" : "none";
          // waitlistButton.style.display =
          //   isAvailable === "true" ? "none" : "flex";
        });
      });
    });
  });
}

initializeReadersProductCard();

function getProductColorValues({ readersProductCardswatches }) {
  const readerOptions =
    readersProductCardswatches.querySelector("#reader-options");

  const readersOptionList = readerOptions.querySelectorAll(
    "#reader-option-values",
  );

  const productColorElements = Array.from(readersOptionList).filter(
    (option) => option.dataset.optionName === "Product Color",
  );

  if (!!productColorElements?.length) {
    const productColorElement = productColorElements.find(Boolean);

    const productColorValues = Array.from(productColorElement.children).map(
      (child) => child.dataset.optionValueColor.toLowerCase().replace(/\s+/g, '-'),
    );

    return productColorValues;
  }

  return [];
}

function handleRedirectProductCard(url) {
  window.location = url;
}
